// removed by extract-text-webpack-plugin
module.exports = {"links":"_2Hvb","link":"_17GX","active":"_133j"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PageLinks/PageLinks.scss
// module id = Sa6g
// module chunks = 0